import { FC } from 'react';

import { isNumber } from 'lodash';

import campaignsDashboardIncreaseBudgetButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaigns_dashboard/campaigns_dashboard_increase_budget_button_click';
import { Flex, Text, TextTypography } from '@hh.ru/magritte-ui';
import { PlusCircleFilledSize16 } from '@hh.ru/magritte-ui/icon';

import { CampaignTableMoney } from 'components/CampaignsDashboard/components/CampaignsTable/components/CampaignTableMoney';
import { CELL_TYPOGRAPHY, EMPTY_VALUE } from 'components/CampaignsDashboard/utils/constants';
import { getIsMutatingActionAvailable } from 'components/CampaignsDashboard/utils/utils';

import {
    CampaignFrontendStatus,
    DashboardCampaign,
    setCampaignIdsForBudgetIncrease,
    setIsBudgetIncreaseModalVisible,
} from 'store/models/campaignsDashboard';
import { currentAccount } from 'store/models/user';
import { useDispatch, useSelector } from 'store/utils';

interface CampaignBudgetProps {
    campaign: DashboardCampaign;
    showIncreaseAction?: boolean;
    typography?: TextTypography;
}

export const CampaignBudget: FC<CampaignBudgetProps> = ({
    campaign,
    showIncreaseAction = true,
    typography = CELL_TYPOGRAPHY,
}) => {
    const currentAccountStatus = useSelector(currentAccount)?.status;

    const { id: campaignId, budget, frontendStatus } = campaign;
    const isMutatingActionAvailable = getIsMutatingActionAvailable(frontendStatus, currentAccountStatus);

    const dispatch = useDispatch();

    const handleIncreaseBudgetClick = () => {
        dispatch([setIsBudgetIncreaseModalVisible(true), setCampaignIdsForBudgetIncrease(new Set([campaignId]))]);
        campaignsDashboardIncreaseBudgetButtonClick({ campaignId });
    };

    return budget === null ? (
        <Text typography={typography} style="primary">
            {EMPTY_VALUE}
        </Text>
    ) : (
        <Flex align="center" gap={6}>
            <CampaignTableMoney value={isNumber(budget) ? budget : undefined} typography={typography} />
            {showIncreaseAction &&
                frontendStatus !== CampaignFrontendStatus.InactiveDueToEndDate &&
                isMutatingActionAvailable && (
                    <PlusCircleFilledSize16 initialColor="accent" onClick={handleIncreaseBudgetClick} />
                )}
        </Flex>
    );
};
